"use client"

import { router, usePage } from "@inertiajs/react"
import { Folder, Home02, LogOut01, Settings01 } from "@untitledui/icons"

import { Avatar } from "@/components/ui/avatar"
import { Dropdown } from "@/components/ui/dropdown-menu"
import {
  dashboardPath,
  ownedPlaylistsPath,
  sessionPath,
  settingsProfilePath,
} from "@/routes"
import type { SharedData } from "@/types"

export const MarketingUserMenu = () => {
  const { visitor } = usePage<SharedData>().props

  if (!visitor.authenticated || !visitor.session_id) return null

  return (
    <Dropdown.Root>
      <Dropdown.Trigger
        aria-label="Open account menu"
        className="group inline-flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-full border p-0 transition-shadow outline-none hover:cursor-pointer"
      >
        <Avatar
          name={visitor.display_name ?? ""}
          avatarUrl={visitor.avatar_url}
          size="md"
          className="transition-transform duration-1000 ease-out group-hover:scale-110"
        />
      </Dropdown.Trigger>
      <Dropdown.Popover>
        <Dropdown.Menu>
          <Dropdown.Item
            label={`👋 Hi, ${visitor.display_name}`}
            className="hover:cursor-default"
          />
          <Dropdown.Separator />
          <Dropdown.Item
            icon={Home02}
            label="Dashboard"
            href={dashboardPath()}
          />
          <Dropdown.Item
            icon={Folder}
            label="My Playlists"
            href={ownedPlaylistsPath()}
          />
          <Dropdown.Item
            icon={Settings01}
            label="Settings"
            href={settingsProfilePath()}
          />
          <Dropdown.Separator />
          <Dropdown.Item
            icon={LogOut01}
            label="Sign out"
            className="hover:[&>div]:!bg-error-primary data-[focused]:[&>div]:!bg-error-primary [&_span]:!text-error-primary [&_svg]:!text-error-primary"
            onAction={() =>
              router.delete(sessionPath({ id: visitor.session_id! }))
            }
          />
        </Dropdown.Menu>
      </Dropdown.Popover>
    </Dropdown.Root>
  )
}
